document.addEventListener("DOMContentLoaded", () => {
  // Mobile menu toggle
  const menuToggle = document.getElementById("menu-toggle");
  const dropdownToggles = document.querySelectorAll(".mobile-dropdown, .nav-dropdown-toggle");

  // Toggle mobile menu
  menuToggle.addEventListener("click", toggleMenu);
  menuToggle.addEventListener("keydown", (e) => {
      if (e.key === "Enter" || e.key === " ") toggleMenu();
  });

  function toggleMenu() {
      const menuContainer = document.getElementById("menu-container");
      menuContainer.style.display = menuContainer.style.display === "flex" ? "none" : "flex";
      menuToggle.classList.toggle("active");
  }

  // Handle dropdown toggle for both mobile and desktop
  dropdownToggles.forEach((toggle) => {
      toggle.addEventListener("click", (e) => {
          e.preventDefault(); // Prevent link navigation
          e.stopPropagation(); // Prevent bubbling up

          // Toggle the visibility of the dropdown list
          const dropdownList = toggle.nextElementSibling;
          if (dropdownList) {
              const isOpen = dropdownList.classList.contains("w--open");
              closeAllDropdowns(); // Close all other dropdowns
              if (!isOpen) {
                  dropdownList.classList.add("w--open");
              }
          }
      });

      toggle.addEventListener("keydown", (e) => {
          if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              toggle.click(); // Simulate a click for accessibility
          }
      });
  });

  // Close dropdowns when clicking outside
  document.addEventListener("click", closeAllDropdowns);

  function closeAllDropdowns() {
      document.querySelectorAll(".w--open").forEach((dropdown) => {
          dropdown.classList.remove("w--open");
      });
  }

  // Keep dropdown open on hover for desktop
  const desktopDropdowns = document.querySelectorAll(".w-dropdown");

  desktopDropdowns.forEach((dropdown) => {
      const toggle = dropdown.querySelector(".nav-dropdown-toggle");
      const list = dropdown.querySelector(".nav-dropdown-list");

      dropdown.addEventListener("mouseenter", () => {
          list.classList.add("w--open");
      });

      dropdown.addEventListener("mouseleave", () => {
          list.classList.remove("w--open");
      });
  });
});